<template>
  <div>
    <v-select v-bind="$attrs" v-on="$listeners">
      <template slot="selection" slot-scope="{ item }">
        <v-tooltip top>
          <template v-slot:activator="{ on }">
            <span v-on="on" class="st-select">
              {{ item.text }}
            </span>
          </template>
          <span>{{ item.text }}</span>
        </v-tooltip>
      </template>
    </v-select>
  </div>
</template>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>

<script>
import src from './src'
export default src
</script>
